import { render, staticRenderFns } from "./questionnaireAnswersModal.vue?vue&type=template&id=70ba6f94&"
import script from "./questionnaireAnswersModal.vue?vue&type=script&lang=js&"
export * from "./questionnaireAnswersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports